import { useEffect, useState } from "react";
import { useLocalization } from "@fluent/react";
import { useRequestWithFeedback } from "byzantine/src/dbbl/composites/request/request.hooks";
import { useNotificationContext } from "cerulean";
import type { TotpSetup, TotpSetupError } from "./types";

const useFetchTotpDevice = (endpoint: string) => {
  const { l10n } = useLocalization();
  const { sendNotification } = useNotificationContext();
  const [deviceSetup, setDeviceSetup] = useState<TotpSetup>();
  const { send, loading: isLoading } = useRequestWithFeedback<
    TotpSetup,
    TotpSetup | TotpSetupError
  >();

  useEffect(() => {
    send({
      action: {
        url: endpoint,
        options: { method: "POST", payload: { device_type: "totp" } },
      },
      onError: async (err) => {
        try {
          const data = await err.response?.json();
          // Setup is returned as an expected 403 challenge.
          if (
            err.response?.status === 403 &&
            data &&
            "qr_svg" in data &&
            data.id === "totp_setup_requested"
          ) {
            setDeviceSetup(data);
            return;
          }
          if (data && "message" in data && typeof data.message === "string") {
            const message = data.message || l10n.getString("error-generic");
            sendNotification({ type: "negative", text: message });
            return;
          }
        } catch {
          // Use the generic message when the error response cannot be read.
        }
        sendNotification({
          type: "negative",
          text: l10n.getString("error-generic"),
        });
      },
    });
  }, []);

  return { deviceSetup, isLoading };
};

export default useFetchTotpDevice;
